import { render, staticRenderFns } from "./ehc-message.vue?vue&type=template&id=8f1db5a4"
import script from "./ehc-message.vue?vue&type=script&lang=js"
export * from "./ehc-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports